module.exports = __webpack_public_path__ + "static/media/intent-based.9ca0f1e9.jpg";